var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"noticeSetting"},[_c('router-view',{attrs:{"route-loading":_vm.loading}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }